var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#466DEC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.8,10H19.2C10,10,2.5,17.5,2.5,26.7v96.6c0,9.2,7.5,16.7,16.7,16.7h111.7c9.2,0,16.7-7.5,16.7-16.7V26.7 C147.5,17.5,140,10,130.8,10z M138.3,123.3c0,4.1-3.4,7.5-7.5,7.5H19.2c-4.1,0-7.5-3.4-7.5-7.5V26.7c0-4.1,3.4-7.5,7.5-7.5h111.7 c4.1,0,7.5,3.4,7.5,7.5V123.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,30.3c-16.9,0-30.6,14.4-30.6,32.1c0,17.7,13.7,32.1,30.6,32.1s30.6-14.4,30.6-32.1 C105.6,44.7,91.9,30.3,75,30.3z M96.4,62.5c0,12.7-9.6,22.9-21.4,22.9c-11.8,0-21.4-10.3-21.4-22.9c0-12.6,9.6-22.9,21.4-22.9 C86.8,39.5,96.4,49.8,96.4,62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.2,85.4H68.8c-24.4,0-44.2,20.9-44.2,46.6c0,2.5,2.1,4.6,4.6,4.6s4.6-2.1,4.6-4.6c0-20.6,15.7-37.4,35-37.4 h12.4c19.3,0,35,16.8,35,37.4c0,2.5,2.1,4.6,4.6,4.6c2.5,0,4.6-2.1,4.6-4.6C125.4,106.3,105.6,85.4,81.2,85.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingModule);
export default __webpack_public_path__ + "static/media/TrainingModule.753fcb4199c0c4958342c22754bdeaf0.svg";
export { ForwardRef as ReactComponent };